/* ============================================================
   OFFKEY LONDON — Hero crossfade loop
   ============================================================ */
(function () {
  const init = () => {
    document.querySelectorAll('.offkey-hero').forEach((hero) => {
      const slides = hero.querySelectorAll('.offkey-hero__slide');
      if (slides.length < 2) return;

      const cssDur = getComputedStyle(hero).getPropertyValue('--offkey-hero-duration').trim();
      const ms = (parseFloat(cssDur) || 6) * 1000;

      slides.forEach((s, i) => s.classList.toggle('is-active', i === 0));

      let current = 0;
      setInterval(() => {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, ms);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();